import styled from 'styled-components';
import {
  Dropdown as SemanticDropdown,
  Table as SemanticTable,
  Popup as SemanticPopup,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const ContainerItemColumn = styled.div`
  display: flex;
  margin-right: 40px;
`;

export const Table = styled(SemanticTable)`
  &&& {
    margin: 0px;
    padding: 0px;
    width: 100%;
    color: inherit;
    margin-bottom: 100px;
  }
`;

export const Row = styled(SemanticTable.Row)`
`;

export const Column = styled(SemanticTable.Cell)`
  color: ${({ projectApprovals, isCompanyPayAsYouGo }) => (projectApprovals && isCompanyPayAsYouGo ? 'gray' : 'initial')};
  cursor: ${({ projectApprovals, isCompanyPayAsYouGo }) => (projectApprovals && isCompanyPayAsYouGo ? 'not-allowed' : 'initial')};
`;

export const Header = styled(SemanticTable.Header)``;

export const HeaderCell = styled(SemanticTable.HeaderCell)`
  &&&& {
    font-weight: 500;
    color: #4D5473;
    font-size: 14px;
  }
`;

export const Body = styled(SemanticTable.Body)``;

export const TextName = styled(TextLayoutComponent)`
  font-size: 16px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TextEmail = styled(TextLayoutComponent)`
  font-size: 16px;
  width: 240px;
  max-width: 760px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Message = styled(TextLayoutComponent)`
  ${({ bold }) => bold && `
    font-weight: 500;
  `}

  max-width: 760px;
`;

export const ErrorMessage = styled(TextLayoutComponent.Error)``;

export const Status = styled(TextLayoutComponent)`
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  word-break: normal;
`;

const circleBackgroundColor = (theme) => ({
  pending: theme.color.memberPending,
  accepted: theme.color.memberAccepted,
});

export const Circle = styled.div`
  background-color: ${({ theme, status }) => (status ? circleBackgroundColor(theme)[status] : theme.color.memberPending)};

  margin-right: 10px;
  border-radius: 10px;
  height: 10px;
  width: 10px;
`;

export const Link = styled.a`
  color: ${(props) => props.color || props.theme.color.link};
  margin-left: 20px;
  margin-right: 20px;

  :hover {
    color: ${(props) => props.color || props.theme.color.linkHover};
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }

  :active {
    color: ${(props) => props.color || props.theme.color.linkActive};
  }
`;

export const Dropdown = styled(SemanticDropdown)`
  &.ui.dropdown {
    color: rgb(77, 84, 115);
    min-width: 100px;
    width: auto;
  }

`;

export const DropdownProjectApproval = styled(SemanticDropdown)`
  &.ui.dropdown {
    color: rgb(77, 84, 115);
    min-width: 100px;
    width: auto;
  }

  cursor: ${({ projectApprovals, isCompanyPayAsYouGo }) => (projectApprovals && isCompanyPayAsYouGo ? 'not-allowed' : 'initial')};
`;

export const Popup = styled(SemanticPopup)``;

export const ProjectApprovalContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ProjectApprovalText = styled(TextLayoutComponent)`
  width: max-content;
`;
